// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3AQ9S","productName":"Table_productName__1ZkXF"};